import {Pinia} from 'pinia'
import {RouteLocationNormalized} from 'vue-router'
import {useResourceItemStore} from '@toolify/client/src/stores/ResourceItemStore/useResourceItemStore'

export function markResourceAsReadRouterHookFactory(pinia: Pinia) {
  return function markResourceAsReadRouterHook(to: RouteLocationNormalized, from?: RouteLocationNormalized) {
    const routeResource = to.meta.determineResource?.(to) ?? null
    if(!routeResource) {
      return
    }
    const previousResource = from?.meta?.determineResource?.(from) ?? null
    if(
      previousResource &&
      previousResource.resourceType === routeResource.resourceType &&
      previousResource.resourceId === routeResource.resourceId
    ) {
      return
    }
    const resourceItemStore = useResourceItemStore(pinia)
    resourceItemStore.markResourceAsRead(routeResource.resourceType, routeResource.resourceId).catch(() => undefined)
  }
}
